import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';
import { MedicalConditionStatus } from 'store/modules/subscriber-imq/types';

export const ConditionTextStyled = styled.span<{ $status: MedicalConditionStatus }>`
  ${typography.regular[16]};
  color: ${({ $status }): CSSProp =>
    $status === MedicalConditionStatus.DETAILS_MISSING ? colors.red[600] : colors.green[600]};
`;

export const ConditionTagStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: max-content;

  svg {
    flex-shrink: 0;
  }
`;
